import * as Common from '@/tenant/common';

export class JournalItem extends Common.ObjectBase{
  constructor(){
    super('JournalItem');
    this.binders.journalEntry = new Common.ModelBinder(Common.JournalEntry);
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.account = new Common.ModelBinder(Common.Account);
  }
  public id: number = null;
  public slipItemNo: string = null;
  public journalId: number = null;
  public journalEntry: Common.JournalEntry = null;
  public branchNo: number = null;
  public debitCredit: Common.DebitCreditFlags = null;
  public accountMappingCode: string = null;
  public account: Common.Account = null;
  public subAccountMappingCode: string = null;
  public taxCode: string = null;

  //仕訳伝票情報
  public postDate: Date = null;
  public bookDate: Date = null;
  public isExported: boolean = null;
  public journalType: Common.JournalTypes = null;
  public refNo: string = null;
  public segmentMappingCode: string = null;
  public segment: Common.Segment = null;

  //仕訳金額
  public dealAmount: number = null;
  public amount: number = null;
  public taxAmount: number = null;
  public totalAmount: number = null;

  //借方表示用項目
  public debitDealAmount: number = null;
  public debitAmount: number = null;
  public debitTaxAmount: number = null;
  public debitTotalAmount: number = null;
  public debitSegmentName: string = null;
  public debitSegmentMappingCode: string = null;
  public debitAccountName: string = null;
  public dcreditAccountMappingCode: string = null;
  public debitSubAccountMappingCode: string = null;
  public debitTaxCode: string = null;
  public debitTaxMappingCode: string = null;

  //貸方表示用項目
  public creditDealAmount: number = null;
  public creditAmount: number = null;
  public creditTaxAmount: number = null;
  public creditTotalAmount: number = null;
  public creditSegmentName: string = null;
  public creditSegmentMappingCode: string = null;
  public creditAccount: string = null;
  public creditAccountMappingCode: string = null;
  public creditSubAccountMappingCode: string = null;
  public creditTaxCode: string = null;
  public creditTaxMappingCode: string = null;

  //連携用項目
  public description: string = null;
  public customField01: string = null;
  public customField02: string = null;
  public customField03: string = null;
  public customField04: string = null;
  public customField05: string = null;
  public customField06: string = null;
  public customField07: string = null;
  public customField08: string = null;
  public customField09: string = null;
  public customField10: string = null;
  public customField11: string = null;
  public customField12: string = null;
  public customField13: string = null;
  public customField14: string = null;
  public customField15: string = null;
  public customField16: string = null;
  public customField17: string = null;
  public customField18: string = null;
  public customField19: string = null;
  public customField20: string = null;
  public customField21: string = null;
  public customField22: string = null;
  public customField23: string = null;
  public customField24: string = null;
  public customField25: string = null;
  public customField26: string = null;
}

export class JournalItemQuery extends Common.LoadQuery {
  constructor(){
    super('JournalItemQuery',JournalItem);
    this.sort = 'parentBookDate';
    // var today = new Date();
    // this.bookDateFrom = new Date(today.getFullYear(), today.getMonth(), 1);
    // this.bookDateTo = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  }

  public segment: Common.Segment = null;
  public journalType: Common.JournalTypes = null;
  public slipItemNo: string = '';
  public refNo: string = '';
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public isExported: boolean = false;
  public auditNo: string = '';
}
export class JournalItemExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "JournalItemExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
  }
  public loadQuery: Common.LoadQuery;
  public sheetName: string;
}

export class CancelOutputQuery extends Common.Query {
  constructor(){
        super('CancelOutputQuery',new Common.ModelBinder(JournalItem,true));
    }
    public journalItems: Array<JournalItem>;
} 
export class SendJournalApiQuery extends Common.Query {
  constructor(){
        super('SendJournalApiQuery',new Common.ModelBinder(JournalItem,true));
    }
    public journalItems: Array<JournalItem>;
    public onlySelectedItems: boolean;
    public loadQuery: Common.JournalItemQuery;
}